import { Card, CardContent } from "@rumbledirect/ui";
import { Suspense } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/common/button";
import { Topbar } from "@/components/layout/topbar";
import { Content } from "@/components/layout/content";
import { ButtonGroup } from "@rumble-it/common-components/components";
import { Loading } from "@/components/common/loading";
import { ActionTable } from "@/pages/admin/rules/actions/components/actions-table";

export default function ActionsPage() {
  return (
    <>
      <Topbar title="Actions" icon={{ style: "far", name: "cloud-check" }} />

      <Content>
        <ButtonGroup className="flex">
          <Link to="/rules/actions/create" className="ml-auto">
            <Button variant="grey" faIconLeft={{ style: "far", name: "plus" }}>
              Nieuwe action
            </Button>
          </Link>
        </ButtonGroup>

        <Card>
          <Suspense
            fallback={
              <CardContent>
                <Loading />
              </CardContent>
            }
          >
            <ActionTable />
          </Suspense>
        </Card>
      </Content>
    </>
  );
}
